import { EditionTypes } from "state/types/UserTypes";
import { InitialState } from "state/InitialState";
import { ExecuteRequest } from "core/glambox/GlamboxApi";
import { GlamboxEndpoints } from "core/glambox/GlamboxEndpoints";
import { Utils } from "utils/Utils";
import { UiActions } from "../UiActions";

// ----------------------------------------------------------------------

/**
 * Contém todas as actions necessárias para gerenciar edições.
 *
 * @type {Object}
 * @since 0.0.1
 */
export const EditionsActions = {};

const defineCurrentSubscriber = (desiredEdition, editions) => {
  for (let n = 0; n < editions.length; n++) {
    let curr = editions[n];
    
    if (parseInt(desiredEdition) === curr.editionId) {
      return curr;
    }
  }

  return null;
};

// THUNKS
// ----------------------------------------------------------------------

EditionsActions.fetch = () => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    dispatch(EditionsActions.start());

    let queueId = "Editions-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Person.editionsReceived,
      null,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response, error) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(EditionsActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(EditionsActions.success(true));

          dispatch(EditionsActions.set(result));

          let currentFeedbackEdition = defineCurrentSubscriber(
            Utils.getFeedbackEditionId(),
            result
          );

          if (currentFeedbackEdition !== null) {
            EditionsActions.setCurrentFeedback(
              currentFeedbackEdition,
              data.Authorization
            );
          }
        } else {
          dispatch(
            EditionsActions.error(
              (result && result.message) 
                ? result.message 
                : "Erro"
            )
          );
        }
      }
    );
  };
};

EditionsActions.setCurrentFeedback = (
  currentFeedbackEdition,
  access_token
) => {
  return (dispatch, getState) => {
    const state = getState();

    let {
      data
    } = state.token;

    let requestData = {
      editionId: currentFeedbackEdition.editionId,
      subscriber_id: currentFeedbackEdition.subscriberId
    };

    let queueId = "EditionFeedback-" + Date.now();
    dispatch(UiActions.queue(queueId));

    ExecuteRequest(
      GlamboxEndpoints.Feedback.getEditionFeedback,
      requestData,
      "GET",
      {
        Authorization: data.Authorization
      },
      null,
      (response) => {
        let {
          result,
          statusCode
        } = response;

        dispatch(EditionsActions.pending(false));

        dispatch(UiActions.dequeue(queueId));

        if (statusCode === 200) {
          dispatch(EditionsActions.success(true));

          dispatch(UiActions.setFeedbackFormId(result));
        } else {
          dispatch(
            EditionsActions.error(
              (result && result.message) 
                ? result.message 
                : "Erro"
            )
          );
        }
      }
    );
  }
};

EditionsActions.start = () => {
  return (dispatch) => {
    dispatch(EditionsActions.pending(true));
    dispatch(EditionsActions.success(false));
    dispatch(EditionsActions.error(null));
  };
};

// ACTIONS PURAS
// ----------------------------------------------------------------------

EditionsActions.sync = () => ({
  editions: {
    lastSync: Date.now()
  },
  type: EditionTypes.sync
});

EditionsActions.set = (editions) => ({
  editions: {
    data: editions,
    lastSync: Date.now()
  },
  type: EditionTypes.set
});

EditionsActions.unset = () => ({
  editions: InitialState.createSyncObject(),
  type: EditionTypes.unset
});

EditionsActions.success = (success) => ({
  editions: {
    success: (success === true)
  },
  type: EditionTypes.success
});

EditionsActions.pending = (pending) => ({
  editions: {
    pending: (pending === true)
  },
  type: EditionTypes.pending
});

EditionsActions.error = (error) => ({
  editions: {
    error
  },
  type: EditionTypes.error
});
